/* eslint-disable max-len */
import { api } from '../services/api';
import {
  FETCH_TARJETA_PATH,
  FETCH_GRAFICA_PATH
} from '../services/path';
import * as types from './types';

export const fetchTarjeta = (perPage, offSet, texto = "") => (dispatch) => {
  let url = `${FETCH_TARJETA_PATH}?perPage=${perPage}&offSet=${offSet}`;
  if (texto && texto.trim() !== "") {
    url += `&texto=${encodeURIComponent(texto)}`;
  }
  return dispatch({
    type: types.FETCH_TARJETA,
    promise: api.get(url),
  });
};

export const fetchTarjetaById = (id) => (dispatch) => dispatch({
  type: types.FETCH_TARJETA_BY_ID,
  promise: api.get(`${FETCH_TARJETA_PATH}/${id}`)
});

export const fetchTarjetaByIdGrafica = (id) => (dispatch) => dispatch({
  type: types.FETCH_TARJETA_BY_ID_GRAFICA,
  promise: api.get(`${FETCH_TARJETA_PATH}/${id}`)
});

// Nueva acción para obtener gráficas completas específicas
export const fetchGraficaCompleta = (id) => (dispatch) => dispatch({
  type: types.FETCH_GRAFICA_COMPLETA,
  promise: api.get(`${FETCH_TARJETA_PATH}/grafica/completa/${id}`)
});

// Nueva acción para obtener múltiples gráficas completas
export const fetchGraficasCompletas = (graficaIds) => (dispatch) => dispatch({
  type: types.FETCH_GRAFICAS_COMPLETAS,
  promise: api.post(`${FETCH_GRAFICA_PATH}/completas`, { ids: graficaIds })
});

export const limpiarTarjeta = () => (dispatch) => dispatch({
  type: types.LIMPIAR_ESTADO_TARJETA,
});

export const updateTarjeta = (id, tarjetaData) => async (dispatch) => {
  dispatch({ type: types.UPDATE_TARJETA_REQUEST });
  
  try {
    const response = await api.patch(`${FETCH_TARJETA_PATH}/${id}`, tarjetaData);
    
    dispatch({
      type: types.UPDATE_TARJETA_SUCCESS,
      payload: response.data
    });
    
    return response;
  } catch (error) {
    dispatch({
      type: types.UPDATE_TARJETA_ERROR,
      payload: error.response?.data?.message || error.message
    });
    
    throw error;
  }
};